const normalizeCashLabel = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const isPhysicalCashMethod = (method) => {
  const code = normalizeCashLabel(method?.code || method?.key);
  const name = normalizeCashLabel(method?.name);
  return (
    code === "cash" ||
    name.includes("espece") ||
    name.includes("cash")
  );
};

export const computeCashLogoutDrawerAmount = ({
  methods = [],
  initialAmount = 0,
  cashIn = 0,
  cashOut = 0,
} = {}) => {
  const countedCash = methods
    .filter(isPhysicalCashMethod)
    .reduce((sum, method) => sum + Number(method?.actual || 0), 0);

  return Math.max(
    0,
    Number(initialAmount || 0) +
      Number(cashIn || 0) -
      Number(cashOut || 0) +
      countedCash,
  );
};
